import moment from 'moment-timezone'

import { userDateRangeFormat } from 'services/time_format'

export const getPrettyDateRange = ({ startDate, endDate, dateNotation }) => {
  if (!startDate || !endDate) return ''

  const [start, end] = userDateRangeFormat(moment(startDate), moment(endDate), dateNotation, 'date_small', 'date_small_with_year')

  return `${start} – ${end}`
}
